// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class FeaturedProducts extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els.slide.elements.length < 2) return
    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('resize', this.onResize.bind(this))
  }

  onResize () {
    this.setActiveSlide(this.carousel)
  }

  setupCarousel () {
    this.setActiveSlide = this.setActiveSlide.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: 2,
          spacing: 3,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3,
              spacing: 3,
            },
          },
        },
        slideChanged: this.setActiveSlide,
        created: this.setActiveSlide,
      },
      [
        setInitialised(),
        useArrows({
          previous: this.els.prev.element,
          next: this.els.next.element,
        }),
      ],
    )
  }

  setActiveSlide (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.classList.toggle(
        this.config.classes.mediaSlideActiveClass,
        index === currentSlide,
      )
    })
  }

  get config () {
    return {
      classes: {
        mediaSlideActiveClass: 'sec-FeaturedProducts_Slide-active',
      },
    }
  }
}

if (!customElements.get('featured-products')) {
  customElements.define('featured-products', FeaturedProducts)
}
